export default {
  name: 'shop-headers',
  label: {
    title: '店铺搜索导航',
    icon: require('@/assets/icon-component-label_ShopHeader.svg'),
    limit: 1
  },
  tip: '注意：此模块只在店铺首页显示，微页面中不显示',
  decor_type: 'seller',
  sort: 2003
}
